import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import PageHeader from "@/components/feature/PageHeader";

const PRINCIPLES = [
  { icon: "ri-focus-3-line", title: "内容原则 · 忠于原作", desc: "所有关系、CP 线与师门日常均以原作为依据整理，标注立场，拒绝脑补过度。" },
  { icon: "ri-book-open-line", title: "内容原则 · 追更友好", desc: "按关系与脉络分门别类，新老读者都能快速定位想补的内容。" },
  { icon: "ri-chat-smile-3-line", title: "内容原则 · 同好共建", desc: "欢迎读者补充名场面与考据，让这张人物关系图越来越完整。" },
  { icon: "ri-hand-heart-line", title: "内容原则 · 温和讨论", desc: "尊重每位读者对角色的理解，理性表达，共同守护追更的氛围。" },
];

const REVIEWS = [
  { name: "追更十年的阿黎", text: "追了这么久，居然还有我没注意到的师姐互动细节，补完课再看，体验完全不一样。" },
  { name: "CP 考据党·灯下", text: "CP 线按节点梳理得太清楚了，回看名场面再也不用来回翻章节，太省心了。" },
  { name: "新粉小鹤", text: "第一次看这类型作品，全靠这张人物关系图才没迷路，强烈安利给每个新入坑的人。" },
];

export default function About() {
  return (
    <>
      <Navbar />
      <main>
        <PageHeader
          eyebrow="ABOUT US"
          title="关于我们"
          subtitle="一张为追更而生的《师兄啊师兄》人物关系百科：把师兄关系、师姐互动、同门情谊与 CP 线，整理成最容易看懂的补课笔记。"
          crumbs={[{ label: "首页", path: "/" }, { label: "关于我们" }]}
          image="https://readdy.ai/api/search-image?query=A%20peaceful%20Chinese%20cultivation%20study%20with%20scrolls%2C%20brushes%2C%20ink%20stones%20and%20a%20warm%20tea%20cup%20on%20a%20wooden%20desk%2C%20misty%20mountains%20through%20window%2C%20ink%20wash%20style%2C%20scholarly%20warm%20atmosphere%2C%20refined%20detail&width=1920&height=760&seq=page-about-01&orientation=landscape"
        />

        <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div>
              <p className="text-xs font-medium tracking-[0.3em] text-primary-600">BRAND STORY</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                为什么做这个人物关系百科
              </h2>
              <div className="gold-line mt-4 h-px w-16"></div>
              <p className="mt-5 text-sm leading-8 text-foreground-600">
                追更《师兄啊师兄》的过程里我们发现，这部作品最大的魅力藏在人物关系里：师兄关系的亲疏、师姐互动的名场面、同门情谊的暗线，都在为剧情埋下绵长的伏笔。可关系线太多、细节太散，读者常常看完一段就忘了前面的铺垫。
              </p>
              <p className="mt-4 text-sm leading-8 text-foreground-600">
                于是我们决定把这些关系整理成一张"补课地图"——按人物、按 CP、按师门日常分门别类，让每一位读者都能在追更前快速厘清脉络，把名场面背后的暗线看个明白。
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="rounded-lg border border-background-200 bg-background-100 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-700">
                  <i className="ri-map-pin-2-line" />
                </span>
                <h3 className="mt-4 font-heading text-lg text-foreground-950">网站定位</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">
                  面向读者的追更辅助型内容站，专注人物关系、CP 线与师门日常的整理与盘点。
                </p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-2xl text-accent-700">
                  <i className="ri-compass-3-line" />
                </span>
                <h3 className="mt-4 font-heading text-lg text-foreground-950">发展理念</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">
                  让信息好找、让伏笔好懂，用清晰的结构降低追更门槛，陪伴每一段旅程。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
            <div className="text-center">
              <p className="text-xs font-medium tracking-[0.3em] text-primary-600">OUR PRINCIPLES</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">内容原则</h2>
              <div className="gold-line mx-auto mt-4 h-px w-16"></div>
            </div>
            <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {PRINCIPLES.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-100 text-2xl text-secondary-700">
                    <i className={p.icon} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="text-center">
            <p className="text-xs font-medium tracking-[0.3em] text-primary-600">TESTIMONIALS</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">读者口碑</h2>
            <div className="gold-line mx-auto mt-4 h-px w-16"></div>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {REVIEWS.map((r) => (
              <figure key={r.name} className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6">
                <i className="ri-double-quotes-l text-3xl text-primary-300" />
                <blockquote className="mt-3 text-sm leading-7 text-foreground-600">{r.text}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500/15 font-heading text-primary-700">
                    {r.name.charAt(0)}
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{r.name}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        <section className="bg-background-100">
          <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
            <div className="rounded-lg border border-background-200 bg-background-50 p-8 text-center md:p-12">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500/15 text-2xl text-primary-700 mx-auto">
                <i className="ri-mail-send-line" />
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">联系我们</h2>
              <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600">
                对人物关系、CP 线或师门日常有补充与建议？欢迎来信，我们一起把这张关系图补得更完整。
              </p>
              <a
                href="mailto:hello@shixiong.example.com"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-line" /> hello@shixiong.example.com
              </a>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              name: "关于我们",
              description: "关于《师兄啊师兄》人物关系百科站的品牌介绍、网站定位、发展理念、内容原则与读者口碑。",
              inLanguage: "zh-CN",
            }),
          }}
        />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}